export default import.meta.ROLLDOWN_FILE_URL_791rVgfTaL1uBVfLyzDJmw